import { SvgComponent } from "components";
export const getMenuArray = () => {
  let menuArray = [];

  let menuDashboard = {
    Nombre: "Dashboard",
    URL: "/dashboard",
    Orden: 1,
    Icono: (
      <SvgComponent
        fill="white"
        height="35"
        width="35"
        iconName="dashboard"
      />
    ),
  };

  let menuAdministracion = {
    Nombre: "Administración",
    URL: "/CompaniaList",
    PermisoNombre: "ECF.Admin.Compania.LISTAR",
    Orden: 0,
    Icono: (
      <SvgComponent
        fill="white"
        height="35"
        width="35"
        iconName="fal fa-address-card"
      />
    ),
  };

  let menuRequestLog = {
    Nombre: "Request Logs",
    URL: "/RequestLogList",
    PermisoNombre: "ECF.Admin.Compania.LISTAR",
    Orden: 0,
    Icono: (
      <SvgComponent
        fill="white"
        height="35"
        width="35"
        iconName="task"
      />
    ),
  };

  let menuTransacciones = {
    Nombre: "Transacciones E-CF",
    URL: "/TransaccionesList",
    PermisoNombre: "ECF.ComprobanteElectronico.LISTAR",
    Orden: 1,
    Icono: (
      <SvgComponent
        fill="white"
        height="35"
        width="35"
        iconName="transaction"
      />
    ),
  };

  let menuAnulacion = {
    Nombre: "Anulación de e-NCF",
    URL: "/AnulacionesList",
    PermisoNombre: "ECF.AnulacionSecuencia.LISTAR",
    Orden: 2,
    Icono: (
      <SvgComponent
        fill="white"
        height="35"
        width="35"
        iconName="bill-cancel"
      />
    ),
  };

  let menuAprobacion = {
    Nombre: "Aprobación Comercial",
    URL: "/AprobacionComercialList",
    PermisoNombre: "ECF.AprobacionComercial.LISTAR",
    Orden: 4,
    Icono: (
      <SvgComponent
        fill="white"
        height="35"
        width="35"
        iconName="bill-approbation"
      />
    ),
  };

  let menuECFRecibidos = {
    Nombre: "E-CF Recibidos",
    URL: "/ComprobantesRecibidosList",
    PermisoNombre: "ECF.ComprobantesRecibidos.LISTAR",
    Orden: 5,
    Icono: (
      <SvgComponent fill="white" height="35" width="35" iconName="recibidos" />
    ),
  };

  let menuFirmar = {
    Nombre: "Firmar Archivo XML",
    URL: "/FirmarArchivoXML",
    PermisoNombre: "ECF.ComprobanteElectronico.FIRMAR",
    Orden: 6,
    Icono: (
      <SvgComponent
        fill="white"
        height="35"
        width="35"
        iconName="file-signed"
      />
    ),
  };

  let menuArchivos = {
    Nombre: "Carga Masiva de e-CF",
    URL: "/CargaMasivaECFList",
    PermisoNombre: "ECF.Archivo.LISTAR",
    Orden: 8,
    Icono: (
      <SvgComponent fill="white" height="35" width="35" iconName="carga-masiva-ecf" />
    ),
  };

  let menuReporte = {
    Nombre: "Reportes",
    URL: "/Reporte",
    PermisoNombre: "ECF.Reporte.Imprimir",
    Orden: 9,
    Icono: (
      <SvgComponent fill="white" height="35" width="35" iconName="print" />
    ),
  };

  let menuSeriesFiscales = {
    Nombre: "Series Fiscales",
    URL: "/SerieFiscalList",
    PermisoNombre: "ECF.SerieFiscal.LISTAR",
    Orden: 9,
    Icono: (
      <SvgComponent
        fill="white"
        height="35"
        width="35"
        iconName="serie-fiscal"
      />
    ),
  };
  let menuProcesos = {
    Nombre: "Procesos",
    URL: "/ProcesoList",
    PermisoNombre: "ECF.Proceso.Listar",
    Orden: 10,
    Icono: (
      <SvgComponent
        fill="white"
        height="35"
        width="35"
        iconName="lock"
      />
    ),
  };

  let menuTransaccionesPorCia = {
    Nombre: "Compañías Vinculadas",
    URL: "/CompaniaVinculadaList",
    PermisoNombre: "ECF.Tenant.Compania.ListarHijas",
    Orden: 10,
    Icono: (
      <SvgComponent
        fill="white"
        height="35"
        width="35"
        iconName="companias-vinculadas"
      />
    ),
  };

  let menuCargaMasiva = {
    Nombre: "Carga Masiva",
    URL: "/CargaMasiva",
    PermisoNombre: "ECF.CargaMasiva.CARGAR",
    Orden: 11,
    Icono: (
      <SvgComponent
        fill="white"
        height="35"
        width="35"
        iconName="cotization"
      />
    ),
  };

  let menuTransaccionesRecurrentes = {
      Nombre: "Transacciones Recurrentes",
      URL: "/TransaccionesRecurrentesList",
      PermisoNombre: "ECF.TransaccionRecurrente.Listar",
      Orden: 2,
      Icono: (
        <SvgComponent fill="white" height="35" width="35" iconName="recibidos" />
      ),
    };

  menuArray.push(menuAdministracion);
  menuArray.push(menuRequestLog);
  menuArray.push(menuTransacciones);
  menuArray.push(menuAnulacion);
  menuArray.push(menuAprobacion);
  menuArray.push(menuECFRecibidos);
  menuArray.push(menuFirmar);
  menuArray.push(menuArchivos);
  menuArray.push(menuReporte);
  menuArray.push(menuSeriesFiscales);
  menuArray.push(menuProcesos);
  menuArray.push(menuTransaccionesPorCia);
  menuArray.push(menuDashboard);
  menuArray.push(menuTransaccionesRecurrentes);

  menuArray.sort(function (a, b) {
    var textA = a.Nombre.toUpperCase();
    var textB = b.Nombre.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });

  return menuArray;
};

// Shared permission predicate used by BOTH the sidebar menu filter and the route
// guard, so a page is reachable by URL only if its menu link would be shown.
export const puedeAccederPorPermiso = (funciones, permisoNombre) => {
  if (!permisoNombre) return true;
  if (!funciones) return false;
  return funciones.some((p) => p.includes(`${permisoNombre}`));
};

// Maps each menu URL to the permission that gates it (URL -> PermisoNombre),
// e.g. { "/Reporte": "ECF.Reporte.Imprimir", "/FirmarArchivoXML": "ECF.ComprobanteElectronico.FIRMAR" }.
export const getMenuPermisoMap = () => {
  const map = {};
  getMenuArray().forEach((menu) => {
    if (menu.URL && menu.PermisoNombre) {
      map[menu.URL] = menu.PermisoNombre;
    }
  });
  return map;
};
